import leagueGeneral from '@/store/modules/league/general';

export default {
  leagueGeneral,
};
